import InfinityErrorDetail from './InfinityErrorDetail';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from "react";
import { makeStyles } from '@mui/styles';
import { useEffect } from "react";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

// import { Box, Tab, Tabs } from "@mui/material";
import { Box, IconButton, Tab, Table, TableCell, TableHead, TablePagination, TableRow, Tabs, Tooltip } from "@mui/material";
const useStyles = makeStyles((theme: any) => ({
    root: {
        flexShrink: 0,
    },
    hideCell: {
        display: "none !important",
    },
    myTable: {
        '& th': {
            padding: "5px 5px",
            backgroundColor: "#EAEDED"
            // , paddingLeft:"10px"
        },
        '& td': {
            borderBottom: "1px solid #EAEDED",
            //whiteSpace: "nowrap",
            height: "25px",
            padding: "5px 5px",
        },
        // '& tr:nth-child(even)': { backgroundColor: "#FBFCFC" }
    },
    myInput: {
        border: "1px solid #BDC3C7",
        padding: "4px 7px",
        width: "100%",
        '&:focus': {
            border: "1px solid #5DADE2",
            outline: "none",
            color: "#5DADE2",
        },
    },


}));
let mySearchTimer: any;
export default function InfinityErrors() {
    const [customerTypeCode, SetCustomerTypeCode] = React.useState(1);
    const classes = useStyles();
    const [tabType, SetTabType] = React.useState(0);
    const [data, SetData] = React.useState([] as any);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [currentPageNumber, SetCurrentPageNuber] = React.useState(0);
    const [rowsCount, SetRowsCount] = React.useState(0);
    const [search, SetSearch] = React.useState('');
    const [search2, SetSearch2] = React.useState('');
    const [currentRow, SetCurrentRow] = React.useState([] as any);
    const [showErrorDetail, SetShowErrorDetail] = React.useState(false);
    
    useEffect(() => {
        GetErrors();
    }, [currentPageNumber, rowsPerPage, search2, customerTypeCode]);


    function GetErrors() {
        let obj: any = new Object();
        obj.QueryType = "Error";
        obj.CustomerTypeCode = customerTypeCode;
        obj.RowsPerPage = rowsPerPage;
        obj.PageNumber = currentPageNumber;
        obj.Search = search;
        obj.orderBy = "e.ErrorId";
        obj.order = "desc";
        let jsonString = JSON.stringify(obj);
        //alert(jsonString);

        let url = "http://csars-cssdata:5111/api/Infinity/" + jsonString;
        //let url='http://csars-cssdata:5111/api/Customer/%7B%22CustomerTypeCode%22%3A1%2C%20%22RowsPerPage%22%3A15%2C%20%22PageNumber%22%3A2%7D';
        //let url = "http://infinitylogging.csidealer.com:5111/api/Customer/" + jsonString;
        //let url = "http://csars-cssdata:5111/api/Customer/%7B%22CustomerTypeCode%22%3A1%7D";
        //http://localhost:5042/swagger/index.html
        //alert(url);



        fetch(url)
            .then(response => (
                response.json()
            ))
            .then(data =>
            (
                SetData(data)
                , ResetRowsCount(data)


                //,alert(data)
                // SetTotalRowsCount(data.length > 0 ? data[0].TotalRowsCount : 0)
            )

            ).catch(
                error => (alert('Error: ' + error)
                )
            );
    }
    function ResetRowsCount(data: any) {
        if (currentPageNumber == 0) {
            let _totalRows = 0;
            if (data.length > 0) _totalRows = data[0].TotalRows;
            SetRowsCount(_totalRows);
        }

    }

    const handleChangePage = (event: any, newPage: any) => {
        SetCurrentPageNuber(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        SetCurrentPageNuber(0);
        setRowsPerPage(parseInt(event.target.value, 10));

    };
    function TablePaginationActions(props: any) {
        // const classes = useStyles1();
        const theme: any = useTheme();
        const { count, page, rowsPerPage, onChangePage } = props;

        const handleFirstPageButtonClick = (event: any) => {
            SetCurrentPageNuber(0)
        };

        const handleBackButtonClick = (event: any) => {
            SetCurrentPageNuber(page - 1)
        };

        const handleNextButtonClick = (event: any) => {
            SetCurrentPageNuber(page + 1)
        };

        const handleLastPageButtonClick = (event: any) => {
            SetCurrentPageNuber(Math.max(0, Math.ceil(count / rowsPerPage) - 1))
        };

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="first page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                    {theme.direction === 'rtl' ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="next page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="last page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }

    TablePaginationActions.propTypes = {
        count: PropTypes.number.isRequired,
        onChangePage: PropTypes.func.isRequired,
        page: PropTypes.number.isRequired,
        rowsPerPage: PropTypes.number.isRequired,
    };


    const handleTabChange = (event: any, newValue: any) => {
        //SetCurrentPageNuber(0);
        SetCustomerTypeCode(parseInt(newValue));
        //localStorage.setItem("DMSType", newValue);
        // ApplyChanges();
    };

    function ApplyChanges(){
        clearTimeout(mySearchTimer);
        mySearchTimer = setTimeout(() =>{SetCurrentPageNuber(0); SetSearch2(new Date().toString())}, 700);

    }

    const handleRowClick = (currentRow: any) => {
        
        SetCurrentRow(currentRow);
        SetErrorDetail(1);
    };

    function SetErrorDetail(value: number = 0) {
        SetShowErrorDetail(value == 0 ? false : true);
    }



    return (
        // <Box display="flex" justifyContent="center" alignItems="center" ></Box>
        <Box display="flex" >
            <Box sx={{ width: 'auto', display: "table" }}>
                <Box style={{ marginBottom: "1px" }} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <table>
                        <tr>
                            <td>
                                <Tabs
                                    value={customerTypeCode}
                                    onChange={handleTabChange}
                                    aria-label="wrapped label tabs example"
                                >
                                    <Tab value={1} label="Infinity" />
                                    <Tab value={3} label="SoftBiz" />
                                    {/* <Tab value={2} label="Ideal" />
                                <Tab value={3} label="Infinity" /> */}
                                </Tabs>

                            </td>
                            <td>
                                <input placeholder='Search...' className={classes.myInput} type="text" style={{ width: "200px", marginLeft: "15px" }} value={search} onChange={(e: any) => { SetSearch(e.target.value); ApplyChanges() }} ></input>

                            </td>


                            <td style={{ width: "100%" }}>
                                <TablePagination
                                    rowsPerPageOptions={[15, 20, 50, 100]}
                                    component="div"
                                    count={rowsCount}
                                    rowsPerPage={rowsPerPage}
                                    page={currentPageNumber}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}

                                />


                            </td>
                        </tr>
                    </table>
                </Box>
                {/* <table cellPadding={0} cellSpacing={0} style={{ width: "100%" }}>
                    <tr>
                        </td>
                    </tr>
                </table> */}
                <Table className={classes.myTable} >
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Customer</TableCell>
                            <TableCell>Error</TableCell>
                            <TableCell>Database/User</TableCell>
                            <TableCell>ID</TableCell>
                        </TableRow>
                    </TableHead>
                    {data.map((row: any, index: any) => {
                        let FullError = row.Exception + ' StackTrace: ' + row.StackTrace;
                        let ErrorDetail = row.Exception + ' StackTrace: ' + row.StackTrace;
                        if (ErrorDetail.length > 175) ErrorDetail = ErrorDetail.substring(0, 155) + '...';
                        let DatabaseUser = row.DatabaseUser;
                        if (DatabaseUser.length > 30) DatabaseUser = DatabaseUser.substring(0, 30) + '...';
                        const isItemSelected = row.ErrorId == currentRow.ErrorId ? true : false;

                        return (
                            <TableRow
                                hover
                            // role="checkbox"
                            key={row.ErrorId}
                            selected={isItemSelected}
                            onClick={(event) => handleRowClick(row)}
                            style={{cursor:"pointer"}}
                            >
                                <TableCell>{row.Senddate}</TableCell>
                                <TableCell>{row.CustomerName}</TableCell>
                                {/* <TableCell>{row.ErrorMessage}</TableCell> */}
                                {/* <Tooltip arrow title={FullError}> */}
                                <TableCell>{ErrorDetail}</TableCell>
                                {/* </Tooltip> */}

                                <TableCell>{DatabaseUser}</TableCell>
                                <TableCell>{row.ErrorId}</TableCell>
                            </TableRow>
                        );
                    })}

                </Table>
            </Box>
            <InfinityErrorDetail open={showErrorDetail} row={currentRow} onClose={SetErrorDetail} />

        </Box>


    )
}